import {
  Button as MuiButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  CircularProgress
} from '@mui/material';
import { useNotify, useRefresh, useRecordContext } from 'react-admin';
import { useState } from 'react';

import { SecretDialog } from './SecretDialog';
import { useSubmitData } from '../../../../../hooks/useSubmitData';
import { rotateGoogleAdsBridgeSecret } from '../../../../../api';
import { getSelectedIndustryId } from '../../../../../utils/industryUtils';

export const RotateSecretButton = () => {
  const [open, setOpen] = useState(false);
  const [secret, setSecret] = useState(null);
  const notify = useNotify();
  const refresh = useRefresh();
  const record = useRecordContext();
  const { submit, loading } = useSubmitData(rotateGoogleAdsBridgeSecret);

  if (!record) return null;

  const handleClose = () => {
    if (!loading) setOpen(false);
  };

  const handleConfirm = async () => {
    try {
      const result = await submit({ id: record.id, industry_id: getSelectedIndustryId() });
      setSecret(result.secret);
      refresh();
    } catch {
      notify('Failed to rotate secret', { type: 'error' });
    } finally {
      setOpen(false);
    }
  };

  return (
    <>
      <MuiButton onClick={() => setOpen(true)} variant="contained" color="warning" sx={{ mt: 2 }}>
        Rotate secret
      </MuiButton>

      <Dialog open={open} onClose={handleClose}>
        <DialogContent>
          <DialogContentText>
            The old secret stops working immediately. Continue?
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ justifyContent: 'center' }}>
          {!loading ? (
            <>
              <MuiButton onClick={handleConfirm} color="primary">Proceed</MuiButton>
              <MuiButton onClick={handleClose} color="primary">Cancel</MuiButton>
            </>
          ) : (
            <CircularProgress size={24} sx={{ m: '0 auto' }} />
          )}
        </DialogActions>
      </Dialog>

      <SecretDialog
        open={!!secret}
        secret={secret}
        message="The old secret stopped working. Paste this into the plugin and the script now."
        onClose={() => setSecret(null)}
      />
    </>
  );
};
